import { userId } from "frontend-kit/organisms/f-header/f-cart-flyout/f-cart-flyout-config";

class ContextService {
  isAnonymous(): boolean {
    return userId === "anonymous";
  }
}

export default new ContextService();
